// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2YQ-T","checkboxCol":"Table_checkboxCol__3CkBt","emailCol":"Table_emailCol__1rvUc","actionCol":"Table_actionCol__CEG6E"};